import { Route } from 'react-router-dom'
import { URLS } from './constants'
import { PrivateRoute } from 'components/utils/PrivateRoute'
import { CashBackReport } from "./CashBackReport"
import React from "react"
import { EligibilityRules } from "./EligibilityRules"
import { RuleManagement } from "./RuleManagement"
import { EmployeeDetails } from "./CashBackReport/EmployeeDetails"

export const useEmployeeDiscountsRoutes = applicationPages => {
  return (
    <>
      <Route
        path={URLS.AUTH_CASHBACK_REPORT}
        element={
          <PrivateRoute component={CashBackReport} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_CASHBACK_REPORT_EMPLOYEE}
        element={
          <PrivateRoute component={EmployeeDetails} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_ELIGIBILITY_RULES}
        element={
          <PrivateRoute component={EligibilityRules} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_RULE_MANAGEMENT}
        element={
          <PrivateRoute component={RuleManagement} applicationPages={applicationPages} />
        }
      />
    </>
  )
}
